module.exports = __webpack_public_path__ + "media/images/AddIcon-b5f47335bea1dd2cede9baf92e4770c4.png";